import FullFlowView from './FullFlowView';
import MoveEnv from './MoveEnv'
import {DashboardRoot} from './DashboardRoot'

const customComponents = {
    "moveEnv" : {
        displayName: "Move Environments",
        component: MoveEnv
    },
    "fullFlowView" : {
        displayName: "Full Flow View",
        component: FullFlowView
    },
    "dashboardRoot" : {
        displayName: "Dashboard Root",
        component: DashboardRoot
    }
}

export default customComponents;